import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { colors } from "../../../../../../constants/colors";
import { routes } from "../../../../../../constants";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import "./Addon.module.scss";
import Actions from "../../../../../../redux/actions";
import { useTranslation } from "react-i18next";

const AddonPaymentDetails = (props) => {
  const { t } = useTranslation();

  const { couponAppliedMessage, getAppliedCouponDetails } = props;

  /* navigate dependencies */
  const navigate = useNavigate();
  /* navigate dependencies */

  const dispatch = useDispatch();

  const [couponCodeAppliedDetails, setCouponCodeAppliedDetails] = useState();

  const { selectedAddonLoginDetails } = useSelector(
    (state) => state.addonAndSponsorship
  );
  const { validateCouponData, tax } = useSelector((state) => state.payment);

  function calculateTotalPrice(price, taxes) {
    // Initialize the total price with the base price
    let totalPrice = Number(price);

    // Iterate through each tax in the array and add it to the total price
    taxes?.forEach((tax) => {
      if (tax?.percentage && tax?.percentage > 0) {
        // Calculate the tax amount based on the percentage
        const taxAmount = (price * tax?.percentage) / 100;
        // Add the calculated tax amount to the total price
        totalPrice += taxAmount;
      }
    });

    // Return the final total price
    return totalPrice;
  }

  useEffect(() => {
    const tempCouponCodeAppliedDetails = {};
    let temp_discount_amount = 0;
    let temp_total_amount = 0;
    if (validateCouponData && Object.keys(validateCouponData)?.length !== 0) {
      const temp_price =
        selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails
          ?.price_based_on_logins;
      const discount_percent =
        validateCouponData?.discount_coupon?.discount_percent;
      const discount_amount =
        validateCouponData?.discount_coupon?.discount_amount;

      switch (validateCouponData?.discount_coupon?.discount_type) {
        case "PERCENTAGE":
          temp_discount_amount = (temp_price * discount_percent) / 100;
          temp_total_amount = temp_price - temp_discount_amount;
          if (temp_price < temp_discount_amount) {
            temp_total_amount = 0;
          }
          break;
        case "AMOUNT":
          temp_discount_amount = discount_amount;
          temp_total_amount = temp_price - temp_discount_amount;
          if (temp_price < temp_discount_amount) {
            temp_total_amount = 0;
          }
          break;

        default:
          break;
      }

      tempCouponCodeAppliedDetails["coupon_discount"] =
        temp_discount_amount || 0;
      tempCouponCodeAppliedDetails["total_amount"] = temp_total_amount || 0;
      tempCouponCodeAppliedDetails["discount_coupon"] = {
        _id: validateCouponData?.discount_coupon?._id || null,
        coupon_type:
          validateCouponData?.discount_coupon?.coupon_category?.join(", "),
        coupon_code: validateCouponData?.discount_coupon?.coupon_code,
        coupon_name: validateCouponData?.discount_coupon?.coupon_name,
      };
    }

    setCouponCodeAppliedDetails(tempCouponCodeAppliedDetails);
    getAppliedCouponDetails(tempCouponCodeAppliedDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponAppliedMessage]);

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #8a41af, #ff7e47)",
        padding: 20,
        color: colors.white,
        height: "100%",
      }}
    >
      <Flex gap="1rem" style={{ marginBottom: "2rem" }}>
        <Button
          type="default"
          shape="circle"
          size="small"
          icon={<ArrowLeftOutlined />}
          onClick={() => {
            navigate(baseRouteMaker(routes.ADDONS_AND_SPONSORSHIPS));
            dispatch(Actions.createAction(Actions.CLEAR_COUPON));
            dispatch(
              Actions.createAction(Actions.SELECTED_ADDON_LOGIN_DETAILS, {
                selectedAddonLoginDetails: {},
              })
            );
          }}
        />
        <Typography.Title style={{ color: colors.white }} level={2}>
          {t("CommonUtils.payment")}
        </Typography.Title>
      </Flex>

      <Flex gap="3rem" vertical style={{ maxWidth: 500, margin: "auto" }}>
        <Flex vertical>
          <Flex>
            <Typography.Paragraph style={{ color: colors.white, margin: 0 }}>
              {t("CommonUtils.purchaseAddOnLogins")}
            </Typography.Paragraph>
          </Flex>
          <Flex gap="1rem" align="center">
            <Typography.Title
              level={1}
              style={{ color: colors.white, margin: 0 }}
            >
              {couponCodeAppliedDetails &&
              Object.keys(couponCodeAppliedDetails)?.length !== 0
                ? `${couponCodeAppliedDetails?.total_amount?.toFixed(2)} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`
                : `${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.price_based_on_logins?.toFixed(
                    2
                  )} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`}
            </Typography.Title>
            <Flex gap="0.3rem">
              <Typography.Paragraph style={{ color: colors.white, margin: 0 }}>
                {t("CommonUtils.for")}
              </Typography.Paragraph>
              <Typography.Paragraph style={{ color: colors.white, margin: 0 }}>
                {`${selectedAddonLoginDetails?.logins} ${t(
                  "CommonUtils.logins"
                )}`}
              </Typography.Paragraph>
            </Flex>
          </Flex>
          <Typography.Paragraph
            level={4}
            style={{ color: colors.white, margin: 0 }}
          >
            {t("CommonUtils.validFor")}{" "}
            {`${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.duration} ${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.duration_unit}`}
          </Typography.Paragraph>
        </Flex>

        <Flex>
          <Typography.Paragraph style={{ color: colors.white, margin: 0 }}>
            {t("CommonUtils.empowerYourTeam")}
          </Typography.Paragraph>
        </Flex>

        <Flex justify="space-between">
          <Flex vertical>
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.addOnLogins")}
            </Typography.Paragraph>
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.priceFor")}{" "}
              {`${selectedAddonLoginDetails?.logins} ${t(
                "CommonUtils.logins"
              )}`}
              {` (${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.duration} ${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.duration_unit})`}
            </Typography.Paragraph>
          </Flex>

          <Typography.Paragraph style={{ color: colors.whiteSmoke, margin: 0 }}>
            {`${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.price_based_on_logins?.toFixed(
              2
            )} ${
              selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails
                ?.currency
            }` || 0}
          </Typography.Paragraph>
        </Flex>

        {couponCodeAppliedDetails &&
          Object.keys(couponCodeAppliedDetails)?.length !== 0 && (
            <Flex justify="space-between">
              <Flex vertical>
                <Typography.Paragraph
                  style={{ color: colors.whiteSmoke, margin: 0 }}
                >
                  {t("CommonUtils.couponCodeApplied")}
                </Typography.Paragraph>
                <Typography.Paragraph
                  style={{ color: colors.lightWhite, margin: 0 }}
                >
                  {couponCodeAppliedDetails?.discount_coupon?.coupon_code}
                </Typography.Paragraph>
              </Flex>

              <Typography.Paragraph
                style={{ color: colors.whiteSmoke, margin: 0 }}
              >
                {`${couponCodeAppliedDetails?.coupon_discount?.toFixed(2)} ${
                  selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails
                    ?.currency
                }` || 0}
              </Typography.Paragraph>
            </Flex>
          )}

        <Flex vertical gap="1rem">
          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.subtotal")}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {couponCodeAppliedDetails &&
              Object.keys(couponCodeAppliedDetails)?.length !== 0
                ? `${couponCodeAppliedDetails?.total_amount?.toFixed(2)} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`
                : `${selectedAddonLoginDetails?.addonLoginDurationAndPricingDetails?.price_based_on_logins?.toFixed(
                    2
                  )} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`}
            </Typography.Paragraph>
          </Flex>

          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {tax?.tax?.map((item) => (
                <span>
                  {item.name} {item.percentage} %
                </span>
              ))}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {couponCodeAppliedDetails &&
              Object.keys(couponCodeAppliedDetails)?.length !== 0
                ? `${(
                    calculateTotalPrice(
                      couponCodeAppliedDetails?.total_amount,
                      tax?.tax
                    ) - couponCodeAppliedDetails?.total_amount
                  )?.toFixed(2)} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`
                : `${(
                    calculateTotalPrice(
                      selectedAddonLoginDetails
                        ?.addonLoginDurationAndPricingDetails
                        ?.price_based_on_logins,
                      tax?.tax
                    ) -
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails
                      ?.price_based_on_logins
                  )?.toFixed(2)} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`}
            </Typography.Paragraph>
          </Flex>

          <hr
            style={{
              backgroundColor: colors.lightWhite,
              border: "none",
              height: "0.1px",
              width: "100%",
            }}
          />

          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.totalDueToday")}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {couponCodeAppliedDetails &&
              Object.keys(couponCodeAppliedDetails)?.length !== 0
                ? `${calculateTotalPrice(
                    couponCodeAppliedDetails?.total_amount,
                    tax?.tax
                  )?.toFixed(2)} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`
                : `${calculateTotalPrice(
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails
                      ?.price_based_on_logins,
                    tax?.tax
                  )?.toFixed(2)} ${
                    selectedAddonLoginDetails
                      ?.addonLoginDurationAndPricingDetails?.currency
                  }`}
            </Typography.Paragraph>
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
};

export default AddonPaymentDetails;
